<template>
  <footer class="main-footer">
    <div class="container-fluid px-4">
      <div class="footer-content d-flex flex-column flex-md-row align-items-center justify-content-between py-3">
        
        <!-- Gauche : Copyright -->
        <div class="footer-section mb-2 mb-md-0">
          <p class="copyright mb-0">
            &copy; 2026 <span class="brand-name">TufraTech</span>. Tous droits réservés.
          </p>
        </div>

        <!-- Centre : Slogan / Expertise -->
        <div class="footer-section mb-2 mb-md-0 text-center">
          <p class="slogan mb-0 text-uppercase">
            Créateur de solutions <span class="dot">•</span> Web & Mobile
          </p>
        </div>

        <!-- Droite : Version & Credit -->
        <div class="footer-section text-md-right">
          <p class="powered-by mb-0">
            Version <span class="version-tag">0.9.5</span> 
            <span class="d-none d-sm-inline">| Powered by TufraTech</span>
          </p>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterScreen",
  computed: {
    isAdminUp() {
      const privilege = this.getCookie("up");
      return privilege === "admin";
    }
  },
  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    },
  },
};
</script>

<style scoped>
/* Structure du Footer */
.main-footer {
  background-color: #ffffff;
  border-top: 1px solid #f1f5f9; /* Bordure discrète Slate 100 */
  width: 100%;
  margin-top: auto;
}

/* Typographie de base */
p {
  color: #64748b; /* Slate 500 */
  font-size: 11.5px;
  letter-spacing: 0.2px;
}

/* Styles spécifiques */
.brand-name {
  font-weight: 700;
  color: #1e293b; /* Slate 800 */
}

.slogan {
  font-weight: 600;
  color: #94a3b8; /* Slate 400 */
  letter-spacing: 1.5px; /* Look plus moderne/aéré */
  font-size: 10px;
}

.dot {
  color: #4f46e5; /* Accent Indigo */
  font-weight: 900;
  margin: 0 5px;
}

.version-tag {
  background-color: #f8fafc;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  font-family: monospace;
  color: #475569;
}

.powered-by {
  font-weight: 500;
}

/* Ajustements Responsive */
@media (max-width: 768px) {
  .footer-content {
    padding: 1.5rem 0;
    gap: 10px;
  }
  .slogan {
    letter-spacing: 1px;
  }
}
</style>